// extracted by mini-css-extract-plugin
module.exports = {"AboutDescription":"About_AboutDescription__x4bM3"};